import * as e from "react";
import a from "../lib/IconBase.es.js";
import n from "../defs/Signature.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: n }));
o.displayName = "SignatureIcon";
const c = o;
export {
  c as Signature,
  o as SignatureIcon
};
